/**
 * SchoolFields - which school you go to, and the invite code
 * -----------------------------------------------------------
 * ChoreConnect is not open to the public, and the INVITE CODE is what keeps it
 * that way. Without it anyone on the internet could create a student account.
 *
 * The school is different, and it is worth being clear which of these two is
 * doing the work. Until 1 September 2026 this was a dropdown built from a list
 * on the server, which looked like a check and was not - the list had one
 * entry and choosing it proved nothing about anybody. It is free text now:
 * whatever the student types, stored and shown as exactly that. Nothing on the
 * site presents it as verified, because nothing verifies it.
 *
 * The code never reaches the browser. This only ever sends what somebody typed
 * and lets the server judge it.
 *
 *  leaves the school box out and shows only the code. That
 * is the poster signup: posters are not students, so they are not asked which
 * school they go to (since 17 September 2026) - but they may still be asked for
 * the code, if the site is set up that way.
 */

import { KeyRound, School } from 'lucide-react';

import { useI18n } from '../hooks/useI18n';

export default function SchoolFields({
  school,
  schoolCode,
  onSchoolChange,
  onCodeChange,
  requireCode,
  askSchool = true,
  schoolError,
  codeError,
}) {
  const { t } = useI18n();

  return (
    <>
      {askSchool && (
        <div className="field">
          <label htmlFor="school">
            <School size={14} style={{ display: 'inline', verticalAlign: -2 }} /> {t('school.label')} *
          </label>
          <input
            id="school"
            name="school"
            type="text"
            value={school}
            onChange={(event) => onSchoolChange(event.target.value)}
            placeholder={t('school.placeholder')}
            maxLength={120}
            autoComplete="organization"
            aria-invalid={Boolean(schoolError)}
            required
          />
          {schoolError && <span className="field-error">{schoolError}</span>}
        </div>
      )}

      {requireCode && (
        <div className="field">
          <label htmlFor="schoolCode">
            <KeyRound size={14} style={{ display: 'inline', verticalAlign: -2 }} />{' '}
            {t('school.joiningCode')} *
          </label>
          <input
            id="schoolCode"
            name="schoolCode"
            type="text"
            value={schoolCode}
            onChange={(event) => onCodeChange(event.target.value)}
            placeholder={t('school.codePlaceholder')}
            autoComplete="off"
            aria-invalid={Boolean(codeError)}
            required
          />
          {codeError && <span className="field-error">{codeError}</span>}
          <span className="hint">
            {t('school.joiningCodeHint')}
          </span>
        </div>
      )}
    </>
  );
}
